export default __webpack_public_path__ + "static/media/pioneer polyleahters private limited.94b9abd4.jpg";